var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v(_vm._s(_vm.info.detail.backTitle))]),
        _c("ol", { staticClass: "breadcrumb ml-auto" }, [
          _c("li", { staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
          ]),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v("\n          게시물 관리\n        ")
          ]),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _c("a", { attrs: { href: _vm.info.detail.backUrl } }, [
              _vm._v(_vm._s(_vm.info.detail.backTitle))
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "card card-default book-list" }, [
        _c(
          "div",
          {
            staticClass: "card-body",
            staticStyle: { "background-color": "#fff" }
          },
          [
            _c("table", { staticClass: "table table-bordered table-hover" }, [
              _c("colgroup", [
                _c("col", {
                  staticClass: "bg-lightdark",
                  attrs: { width: "12%" }
                }),
                _c("col", { attrs: { width: "38%" } }),
                _c("col", {
                  staticClass: "bg-lightdark",
                  attrs: { width: "12%" }
                }),
                _c("col", { attrs: { width: "38%" } })
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", { staticClass: "align-middle text-center" }, [
                    _vm._v("받는사람")
                  ]),
                  _c(
                    "td",
                    { staticClass: "align-middle", attrs: { colspan: "3" } },
                    [
                      _vm._v(
                        "\n                      " +
                          _vm._s(
                            _vm.info.detail.name +
                              " (" +
                              _vm.info.detail.email +
                              ")"
                          ) +
                          "\n                  "
                      )
                    ]
                  )
                ]),
                _c("tr", [
                  _c("td", { staticClass: "align-middle text-center" }, [
                    _vm._v("예약설정")
                  ]),
                  _c(
                    "td",
                    { staticClass: "align-middle", attrs: { colspan: "3" } },
                    [
                      _c("div", { staticClass: "no-margin row" }, [
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c(
                              "b-form-radio-group",
                              {
                                staticClass: "mt-2 mb-1",
                                attrs: { name: "send-type-radio" },
                                model: {
                                  value: _vm.params.sendType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.params, "sendType", $$v)
                                  },
                                  expression: "params.sendType"
                                }
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  { attrs: { value: "now" } },
                                  [_vm._v("즉시 발송")]
                                ),
                                _c(
                                  "b-form-radio",
                                  { attrs: { value: "later" } },
                                  [_vm._v("예약 발송")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("datepicker", {
                              attrs: {
                                disabled: _vm.params.sendDate === null,
                                format: "yyyy-MM-dd",
                                bootstrapStyling: true,
                                "monday-first": true,
                                "full-month-name": true,
                                placeholder: "날짜 선택",
                                "calendar-button": true,
                                "calendar-button-icon": "far fa-calendar",
                                "clear-button": false,
                                width: "300px"
                              },
                              model: {
                                value: _vm.params.sendDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.params, "sendDate", $$v)
                                },
                                expression: "params.sendDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("b-form-timepicker", {
                              attrs: {
                                disabled: _vm.params.sendTime.length == 0,
                                placeholder: "시간 선택"
                              },
                              model: {
                                value: _vm.params.sendTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.params, "sendTime", $$v)
                                },
                                expression: "params.sendTime"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]),
                _c("tr", [
                  _c("td", { staticClass: "align-middle text-center" }, [
                    _vm._v("제목")
                  ]),
                  _c(
                    "td",
                    { staticClass: "align-middle", attrs: { colspan: "3" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.subject,
                            expression: "params.subject"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:3",
                            expression: "'required|min:3'"
                          }
                        ],
                        staticClass: "form-control",
                        staticStyle: { width: "100%" },
                        attrs: { type: "text", name: "subject" },
                        domProps: { value: _vm.params.subject },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.params, "subject", $event.target.value)
                          }
                        }
                      })
                    ]
                  )
                ]),
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "align-middle text-center report-title" },
                    [_vm._v("신고내용")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "align-middle report-content",
                      attrs: { colspan: "3" }
                    },
                    [
                      _vm._v(
                        "\n                      " +
                          _vm._s(_vm.info.detail.report) +
                          "\n                  "
                      )
                    ]
                  )
                ]),
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "align-middle text-center report-title" },
                    [_vm._v("신고일")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "align-middle report-content",
                      attrs: { colspan: "3" }
                    },
                    [
                      _vm._v(
                        "\n                      " +
                          _vm._s(_vm.info.detail.regDt) +
                          "\n                  "
                      )
                    ]
                  )
                ]),
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "align-middle text-center report-title" },
                    [_vm._v("대상 게시물")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "align-middle report-content",
                      attrs: { colspan: "3" }
                    },
                    [
                      _vm._v(
                        "\n                      " +
                          _vm._s(_vm.info.detail.title) +
                          "\n                  "
                      )
                    ]
                  )
                ]),
                _c("tr", [
                  _c("td", { staticClass: "align-middle text-center" }, [
                    _vm._v("내용")
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "align-middle text-center",
                      attrs: { colspan: "3" }
                    },
                    [
                      _c("quill-editor", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:10",
                            expression: "'required|min:10'"
                          }
                        ],
                        ref: "myQuillEditor",
                        style: "min-height:300px",
                        attrs: { name: "text" },
                        model: {
                          value: _vm.params.text,
                          callback: function($$v) {
                            _vm.$set(_vm.params, "text", $$v)
                          },
                          expression: "params.text"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        ),
        _c("div", { staticClass: "footer mt-2 mb-3" }, [
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-info mr-2",
                  attrs: { variant: "info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.sendEmail()
                    }
                  }
                },
                [_vm._v("발송")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-outline-info mr-2",
                  attrs: { variant: "outline-info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.list()
                    }
                  }
                },
                [_vm._v("목록")]
              )
            ],
            1
          )
        ])
      ]),
      _c("loading", {
        attrs: { active: _vm.modalLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }